export default {
    age_group_no_bound: 'No bound',
    age_group_1: 'Under 5',
    age_group_2: '0 to 6 days (early neonatal)',
    age_group_3: '7 to 27 days (late neonatal)',
    age_group_4: '28 to 364 days (post neonatal)',
    age_group_5: '1 to 4',
    age_group_6: '5 to 9',
    age_group_7: '10 to 14',
    age_group_8: '15 to 19',
    age_group_9: '20 to 24',
    age_group_10: '25 to 29',
    age_group_11: '30 to 34',
    age_group_12: '35 to 39',
    age_group_13: '40 to 44',
    age_group_14: '45 to 49',
    age_group_15: '50 to 54',
    age_group_16: '55 to 59',
    age_group_17: '60 to 64',
    age_group_18: '65 to 69',
    age_group_19: '70 to 74',
    age_group_20: '75 to 79',
    age_group_21: '80 and above',
    age_group_22: 'All Ages',
    age_group_23: '5 to 14',
    age_group_24: '15 to 49',
    age_group_25: '50 to 69',
    age_group_26: '70 and above',
    age_group_27: 'Age-standardized',
    age_group_28: 'Under 1',
    age_group_29: '15 and above',
    age_group_30: '80 to 84',
    age_group_31: '85 to 89',
    age_group_32: '90 to 94',

    age_group_34: '2 to 4',
    age_group_35: '2 to 19',
    age_group_36: '2 to 19, age standardized',
    age_group_37: '20 and above',
    age_group_38: '20 and above, age standardized',
    age_group_39: '0 to 14',
    age_group_40: '50 and above',
    age_group_41: '50 to 74',
    age_group_42: '0 to 27 days (neonatal)',
    age_group_43: '10 to 49',

    age_group_49: '1',
    age_group_50: '2',
    age_group_51: '3',
    age_group_52: '4',
    age_group_53: '5',
    age_group_54: '6',
    age_group_55: '7',
    age_group_56: '8',
    age_group_57: '9',
    age_group_58: '10',
    age_group_59: '11',
    age_group_60: '12',
    age_group_61: '13',
    age_group_62: '14',
    age_group_63: '15',
    age_group_64: '16',
    age_group_65: '17',
    age_group_66: '18',
    age_group_67: '19',
    age_group_68: '20',
    age_group_69: '21',

    age_group_153: '55 to 64',
    age_group_157: '25 and above',
    age_group_158: 'Under 20',
    age_group_159: '10 to 24',

    age_group_161: '0',
    age_group_162: '10 to 19',
    age_group_163: '20 to 64',
    age_group_164: 'Birth',

    age_group_169: '10 to 54',
    age_group_170: '20 to 44',

    age_group_177: 'Early Neonatal to 1',
    age_group_178: 'Early Neonatal to 5',
    age_group_179: 'Post Neonatal to 5',
    age_group_180: 'Post Neonatal to 10',
    age_group_181: 'Post Neonatal to 15',
    age_group_182: 'Post Neonatal+',

    age_group_188: '5 to 19',

    age_group_202: '20 to 29',
    age_group_203: '20 to 39',
    age_group_204: '20 to 49',

    age_group_226: '55 to 69',
    age_group_227: '55 to 74',

    age_group_235: '95 and above',

    age_group_257: '20 to 79',

    age_group_283: 'Unknown',
    age_group_284: '20 to 54',
    age_group_285: '55 to 89',

    age_group_289: '75 to 94',

    age_group_334: '20 to 34',
    age_group_335: '20 to 59',

    age_group_388: '1 to 5 months',
    age_group_390: 'Under 6 months',
    age_group_389: '6-11 months',
    age_group_391: 'Under 2',

    age_group_322: '0 to 10',
    age_group_323: '0 to 13',
    age_group_324: '0 to 15',
    age_group_385: '0 to 17',
    age_group_244: '0 to 2',
    age_group_173: '0 to 24',
    age_group_174: '0 to 29',
    age_group_175: '0 to 39',
    age_group_236: '0 to 4',
    age_group_407: '0 to 5',
    age_group_176: '0 to 59',
    age_group_245: '0 to 6',
    age_group_172: '0 to 9',
    age_group_238: '12 to 23 months',
    age_group_325: '1 to 2',
    age_group_246: '1 to 7',
    age_group_183: '1 to 9',
    age_group_184: '1 to 14',
    age_group_290: '1 to 19',
    age_group_185: '1 to 49',
    age_group_186: '1 to 59',
    age_group_187: '1 and above',
    age_group_382: '2 to 6',
    age_group_291: '2 to 14',
    age_group_361: '3 to 5',
    age_group_247: '3 to 6',
    age_group_337: '3 to 7',

    age_group_248: '5 to 6',
    age_group_344: '5 to 16',
    age_group_339: '5 to 17',
    age_group_189: '5 to 24',
    age_group_165: '5 to 25',
    age_group_239: '5 to 49',
    age_group_190: '5 to 59',
    age_group_191: '5 to 69',
    age_group_192: '5 and above',
    age_group_376: '6 to 10',
    age_group_362: '6 to 16',
    age_group_249: '7 to 14',
    age_group_250: '7 to 19',
    age_group_274: '7 and above',
    age_group_251: '8 to 14',
    age_group_343: '8 to 15',
    age_group_252: '10 to 15',
    age_group_386: '10 to 17',
    age_group_253: '10 to 39',
    age_group_193: '10 to 44',

    age_group_384: '10 to 59',
    age_group_194: '10 and above',
    age_group_392: '11 to 15',
    age_group_326: '11 to 16',
    age_group_373: '11 to 17',
    age_group_327: '14 and above',
    age_group_254: '15 to 17',
    age_group_328: '15 to 20',
    age_group_149: '15 to 24',
    age_group_195: '15 to 29',
    age_group_196: '15 to 34',
    age_group_197: '15 to 39',
    age_group_156: '15 to 44',
    age_group_329: '15 to 50',
    age_group_198: '15 to 54',
    age_group_199: '15 to 59',
    age_group_155: '15 to 60',
    age_group_200: '15 to 64',
    age_group_201: '15 to 69',
    age_group_357: '16 to 17',
    age_group_255: '16 to 20',
    age_group_358: '16 to 44',
    age_group_330: '16 to 60',
    age_group_331: '17 to 18',
    age_group_345: '17 to 49',

    age_group_256: '18 to 19',
    age_group_374: '18 to 24',
    age_group_387: '18 to 29',
    age_group_332: '18 to 44',
    age_group_359: '18 to 54',
    age_group_360: '18 to 59',
    age_group_364: '18 to 124',
    age_group_1818: '18 and above',
    age_group_333: '19 to 20',

    age_group_321: '21 to 24',
    age_group_393: '21 to 25',
    age_group_258: '21 to 30',
    age_group_336: '21 and above',
    age_group_70: '22',
    age_group_377: '22 to 24',
    age_group_71: '23',
    age_group_72: '24',
    age_group_73: '25',
    age_group_150: '25 to 34',
    age_group_375: '25 to 39',
    age_group_205: '25 to 44',
    age_group_166: '25 to 45',
    age_group_206: '25 to 49',
    age_group_207: '25 to 59',
    age_group_208: '25 to 64',
    age_group_209: '25 to 69',
    age_group_74: '26',
    age_group_394: '26 to 30',
    age_group_75: '27',
    age_group_76: '28',
    age_group_77: '29',
    age_group_78: '30',
    age_group_210: '30 to 39',
    age_group_211: '30 to 44',
    age_group_212: '30 to 49',
    age_group_213: '30 to 59',
    age_group_214: '30 to 69',
    age_group_338: '30 and above',
    age_group_79: '31',
    age_group_395: '31 to 35',
    age_group_259: '31 to 40',
    age_group_80: '32',
    age_group_81: '33',
    age_group_82: '34',
    age_group_83: '35',
    age_group_151: '35 to 44',
    age_group_282: '35 to 49',
    age_group_215: '35 to 54',
    age_group_260: '35 to 59',
    age_group_216: '35 to 64',
    age_group_84: '36',
    age_group_396: '36 to 40',
    age_group_85: '37',
    age_group_86: '38',
    age_group_87: '39',
    age_group_88: '40',
    age_group_217: '40 to 49',
    age_group_218: '40 to 54',
    age_group_219: '40 to 59',
    age_group_220: '40 to 64',
    age_group_221: '40 and above',
    age_group_89: '41',
    age_group_397: '41 to 45',
    age_group_261: '41 to 50',
    age_group_90: '42',
    age_group_91: '43',
    age_group_92: '44',
    age_group_93: '45',
    age_group_152: '45 to 54',
    age_group_222: '45 to 59',
    age_group_262: '45 to 60',
    age_group_171: '45 to 64',
    age_group_167: '45 to 65',
    age_group_240: '45 to 74',
    age_group_241: '45 to 79',
    age_group_223: '45 and above',
    age_group_94: '46',
    age_group_398: '46 to 50',
    age_group_95: '47',
    age_group_96: '48',
    age_group_97: '49',
    age_group_98: '50',
    age_group_224: '50 to 59',
    age_group_225: '50 to 64',
    age_group_242: '50 to 79',
    age_group_99: '51',
    age_group_399: '51 to 55',
    age_group_263: '51 to 60',
    age_group_340: '51 and above',
    age_group_100: '52',
    age_group_101: '53',
    age_group_102: '54',
    age_group_103: '55',

    age_group_228: '55 and above',
    age_group_104: '56',
    age_group_400: '56 to 60',
    age_group_105: '57',
    age_group_106: '58',
    age_group_107: '59',
    age_group_108: '60',
    age_group_378: '60 to 61',
    age_group_229: '60 to 69',
    age_group_264: '60 to 75',
    age_group_230: '60 to 79',
    age_group_286: '60 to 89',
    age_group_231: '60 and above',
    age_group_109: '61',
    age_group_275: '61 and above',
    age_group_341: '61 to 65',
    age_group_265: '61 to 70',
    age_group_266: '61 to 75',
    age_group_110: '62',
    age_group_379: '62 to 64',
    age_group_111: '63',
    age_group_112: '64',
    age_group_113: '65',
    age_group_380: '65 to 66',
    age_group_232: '65 to 74',
    age_group_233: '65 to 79',
    age_group_281: '65 to 84',
    age_group_168: '65 to 85',
    age_group_287: '65 to 89',
    age_group_154: '65 and above',
    age_group_114: '66',
    age_group_401: '66 to 70',
    age_group_342: '66 and above',
    age_group_115: '67',
    age_group_381: '67 to 69',
    age_group_116: '68',
    age_group_306: '68 and above',
    age_group_117: '69',
    age_group_307: '69 and above',
    age_group_118: '70',
    age_group_47: '70 to 79',
    age_group_292: '70 to 84',
    age_group_288: '70 to 89',
    age_group_308: '70 and above',
    age_group_119: '71',
    age_group_402: '71 to 75',
    age_group_267: '71 to 80',
    age_group_276: '71 and above',
    age_group_120: '72',
    age_group_121: '73',
    age_group_122: '74',
    age_group_123: '75',
    age_group_243: '75 to 84',
    age_group_234: '75 and above',
    age_group_124: '76',
    age_group_403: '76 to 80',
    age_group_277: '76 and above',
    age_group_125: '77',
    age_group_309: '77 and above',
    age_group_126: '78',
    age_group_310: '78 and above',
    age_group_127: '79',
    age_group_128: '80',
    age_group_268: '80 to 89',
    age_group_129: '81',
    age_group_404: '81 to 85',
    age_group_278: '81 and above',
    age_group_130: '82',
    age_group_311: '82 and above',
    age_group_131: '83',
    age_group_132: '84',
    age_group_312: '84 and above',
    age_group_133: '85',
    age_group_269: '85 to 94',
    age_group_270: '85 to 99',
    age_group_160: '85 and above',
    age_group_134: '86',
    age_group_405: '86 to 90',
    age_group_313: '86 and above',
    age_group_135: '87',
    age_group_314: '87 and above',
    age_group_136: '88',
    age_group_315: '88 and above',
    age_group_137: '89',
    age_group_279: '89 and above',
    age_group_138: '90',
    age_group_271: '90 to 99',
    age_group_237: '90 to 124',
    age_group_294: '90 and above',
    age_group_139: '91',
    age_group_406: '91 to 95',
    age_group_316: '91 and above',
    age_group_140: '92',
    age_group_317: '92 and above',
    age_group_141: '93',
    age_group_318: '93 and above',
    age_group_142: '94',
    age_group_280: '94 and above',
    age_group_143: '95',
    age_group_293: '95 to 97',
    age_group_363: '95 to 98',
    age_group_33: '95 to 99',
    age_group_144: '96',
    age_group_319: '96 and above',
    age_group_145: '97',
    age_group_320: '97 and above',
    age_group_146: '98',
    age_group_272: '98 and above',
    age_group_147: '99',
    age_group_273: '99 and above',
    age_group_295: '100',
    age_group_44: '100 to 104',
    age_group_48: '100 and above',
    age_group_296: '101',
    age_group_297: '102',
    age_group_298: '103',
    age_group_299: '104',
    age_group_300: '105',
    age_group_45: '105 to 109',
    age_group_301: '105 and above',
    age_group_302: '106',
    age_group_365: '106 and above',
    age_group_303: '107',
    age_group_304: '108',
    age_group_383: '108 and above',
    age_group_305: '109',
    age_group_346: '110',
    age_group_46: '110 to 114',
    age_group_148: '110 and above',
    age_group_347: '111',
    age_group_348: '112',
    age_group_349: '113',
    age_group_350: '114',
    age_group_351: '115',
    age_group_352: '116',
    age_group_353: '117',
    age_group_354: '118',
    age_group_355: '119',
    age_group_366: '120',
    age_group_356: '120 and above',
    age_group_367: '121',
    age_group_368: '122',
    age_group_369: '123',
    age_group_370: '124',
    age_group_371: '124 and above',
    age_group_372: '125 and above',

    age_group_420: 'Under 70',
    age_group_430: 'Under 19',
    age_group_999: '0 to 44',
    age_group_1001: 'Age 18 - 34',
    age_group_9999: 'DTR/Unknown',
    age_group_500: '30 to 70',
};
